// Angular
import { Injectable, OnDestroy, inject } from '@angular/core';
// Material
import { MatPaginatorIntl } from '@angular/material/paginator';
// Transloco
import { TranslocoService } from '@jsverse/transloco';
// RxJS
import { Subject, takeUntil } from 'rxjs';

@Injectable()
export class MatPaginatorI18nService extends MatPaginatorIntl implements OnDestroy {
    private readonly translocoService = inject(TranslocoService);

    // Destroy notifier
    private readonly unsubscribe = new Subject<void>();

    constructor() {
        super();

        // Items per page
        this.translocoService
            .selectTranslate('label_items_per_page')
            .pipe(takeUntil(this.unsubscribe))
            .subscribe(value => (this.itemsPerPageLabel = value));

        // First page
        this.translocoService
            .selectTranslate('label_first_page')
            .pipe(takeUntil(this.unsubscribe))
            .subscribe(value => (this.firstPageLabel = value));

        // Last page
        this.translocoService
            .selectTranslate('label_last_page')
            .pipe(takeUntil(this.unsubscribe))
            .subscribe(value => (this.lastPageLabel = value));

        // Next page
        this.translocoService
            .selectTranslate('label_next_page')
            .pipe(takeUntil(this.unsubscribe))
            .subscribe(value => (this.nextPageLabel = value));

        // Previous page
        this.translocoService
            .selectTranslate('label_previous_page')
            .pipe(takeUntil(this.unsubscribe))
            .subscribe(value => (this.previousPageLabel = value));
    }

    /**
     * On Destroy
     * @memberof MatPaginatorI18nService
     */
    ngOnDestroy(): void {
        this.unsubscribe.next();
        this.unsubscribe.complete();
    }
}
